// Demo/mock data used while the real Laravel backend isn't wired up yet.
// Everything here mirrors the shape of the real API resources (see
// backend/app/Http/Resources) so swapping the mock layer out later is a
// drop-in change — see src/mocks/mockServer.js and src/app/axiosBaseQuery.js.

const daysAgo = (n) => new Date(Date.now() - n * 86400000).toISOString();

export const DEMO_PASSWORD = 'demo1234';

export const DEMO_ACCOUNTS = [
  { email: 'investor@demo.com', role: 'investor', label: 'Investor (KYC approved)' },
  { email: 'pending@demo.com', role: 'investor', label: 'Investor (KYC pending)' },
  { email: 'admin@demo.com', role: 'admin', label: 'Admin' },
  { email: 'superadmin@demo.com', role: 'super_admin', label: 'Super Admin' },
];

const rawUsers = [
  {
    id: 1,
    full_name: 'Adaeze Okafor',
    email: 'investor@demo.com',
    phone: '+2348012345678',
    roles: ['investor'],
    kyc_status: 'approved',
    is_active: true,
    email_verified_at: daysAgo(120),
    created_manually_by_admin: false,
    created_at: daysAgo(120),
  },
  {
    id: 2,
    full_name: 'Tunde Bakare',
    email: 'pending@demo.com',
    phone: '+2348023456789',
    roles: ['investor'],
    kyc_status: 'pending',
    is_active: true,
    email_verified_at: daysAgo(3),
    created_manually_by_admin: false,
    created_at: daysAgo(3),
  },
  {
    id: 3,
    full_name: 'Ngozi Umeh',
    email: 'admin@demo.com',
    phone: '+2348034567890',
    roles: ['admin'],
    kyc_status: null,
    is_active: true,
    email_verified_at: daysAgo(200),
    created_manually_by_admin: true,
    created_at: daysAgo(200),
  },
  {
    id: 4,
    full_name: 'Chidi Eze',
    email: 'superadmin@demo.com',
    phone: '+2348045678901',
    roles: ['super_admin'],
    kyc_status: null,
    is_active: true,
    email_verified_at: daysAgo(365),
    created_manually_by_admin: true,
    created_at: daysAgo(365),
  },
  {
    id: 5,
    full_name: 'Grace Adeyemi',
    email: 'grace.adeyemi@demo.com',
    phone: '+2348056789012',
    roles: ['investor'],
    kyc_status: 'pending',
    is_active: true,
    email_verified_at: daysAgo(1),
    created_manually_by_admin: false,
    created_at: daysAgo(1),
  },
  {
    id: 6,
    full_name: 'Emeka Nwosu',
    email: 'emeka.nwosu@demo.com',
    phone: '+2348067890123',
    roles: ['investor'],
    kyc_status: 'rejected',
    is_active: true,
    email_verified_at: daysAgo(10),
    created_manually_by_admin: false,
    created_at: daysAgo(10),
  },
  {
    id: 7,
    full_name: 'Ibrahim Sule',
    email: 'ibrahim.sule@demo.com',
    phone: '+2348078901234',
    roles: ['investor'],
    kyc_status: 'approved',
    is_active: false,
    email_verified_at: daysAgo(90),
    created_manually_by_admin: true,
    created_at: daysAgo(90),
  },
];

// Every seeded demo account shares DEMO_PASSWORD; self-registered users (see
// mockServer.js) get their own chosen password stored the same way.
export const initialUsers = rawUsers.map((u) => ({ ...u, password: DEMO_PASSWORD }));

export const initialKycRecords = [
  {
    id: 1,
    user_id: 1,
    investor_name: 'Adaeze Okafor',
    investor_email: 'investor@demo.com',
    full_name: 'Adaeze Chioma Okafor',
    bvn: '22234567891',
    address: '14 Adeola Odeku Street, Victoria Island, Lagos',
    id_document_type: 'national_id',
    has_id_document: true,
    status: 'approved',
    rejection_reason: null,
    reviewed_by: 'Ngozi Umeh',
    reviewed_at: daysAgo(115),
    created_at: daysAgo(119),
  },
  {
    id: 2,
    user_id: 2,
    investor_name: 'Tunde Bakare',
    investor_email: 'pending@demo.com',
    full_name: 'Tunde Olamide Bakare',
    bvn: '22245678912',
    address: '7 Allen Avenue, Ikeja, Lagos',
    id_document_type: 'passport',
    has_id_document: true,
    status: 'pending',
    rejection_reason: null,
    reviewed_by: null,
    reviewed_at: null,
    created_at: daysAgo(2),
  },
  {
    id: 3,
    user_id: 5,
    investor_name: 'Grace Adeyemi',
    investor_email: 'grace.adeyemi@demo.com',
    full_name: 'Grace Omolara Adeyemi',
    bvn: '22256789123',
    address: '21 Ademola Adetokunbo Crescent, Wuse II, Abuja',
    id_document_type: 'drivers_license',
    has_id_document: true,
    status: 'pending',
    rejection_reason: null,
    reviewed_by: null,
    reviewed_at: null,
    created_at: daysAgo(1),
  },
  {
    id: 4,
    user_id: 6,
    investor_name: 'Emeka Nwosu',
    investor_email: 'emeka.nwosu@demo.com',
    full_name: 'Emeka Nwosu',
    bvn: '22267891234',
    address: '3 Zik Avenue, Awka, Anambra',
    id_document_type: 'national_id',
    has_id_document: true,
    status: 'rejected',
    rejection_reason: 'ID document photo is blurry — please reupload a clearer copy.',
    reviewed_by: 'Ngozi Umeh',
    reviewed_at: daysAgo(8),
    created_at: daysAgo(10),
  },
  {
    id: 5,
    user_id: 7,
    investor_name: 'Ibrahim Sule',
    investor_email: 'ibrahim.sule@demo.com',
    full_name: 'Ibrahim Musa Sule',
    bvn: '22278912345',
    address: '18 Ahmadu Bello Way, Kaduna',
    id_document_type: 'voters_card',
    has_id_document: true,
    status: 'approved',
    rejection_reason: null,
    reviewed_by: 'Chidi Eze',
    reviewed_at: daysAgo(88),
    created_at: daysAgo(90),
  },
];

export const initialInvestments = [
  {
    id: 1,
    reference: 'CINV-2026-000001',
    investor_id: 1,
    investor_name: 'Adaeze Okafor',
    plan_id: 2,
    plan_name: 'Fixed Return Plan — 12 Month',
    principal_amount: 500000,
    monthly_interest_rate: 2.0,
    start_date: daysAgo(120).slice(0, 10),
    maturity_date: null,
    payout_schedule: 'monthly',
    status: 'active',
    total_interest_paid: 45000,
    current_value: 555000,
    last_accrued_at: daysAgo(5),
    notes: 'Reinvested from a matured Q1 plan.',
    created_at: daysAgo(120),
  },
  {
    id: 2,
    reference: 'CINV-2026-000002',
    investor_id: 1,
    investor_name: 'Adaeze Okafor',
    plan_id: 1,
    plan_name: 'Fixed Return Plan — 6 Month',
    principal_amount: 250000,
    monthly_interest_rate: 1.8,
    start_date: daysAgo(200).slice(0, 10),
    maturity_date: daysAgo(20).slice(0, 10),
    payout_schedule: 'monthly',
    status: 'matured',
    total_interest_paid: 27000,
    current_value: 277000,
    last_accrued_at: daysAgo(20),
    notes: null,
    created_at: daysAgo(200),
  },
  {
    id: 3,
    reference: 'CINV-2026-000003',
    investor_id: 7,
    investor_name: 'Ibrahim Sule',
    plan_id: 2,
    plan_name: 'Fixed Return Plan — 12 Month',
    principal_amount: 750000,
    monthly_interest_rate: 2.2,
    start_date: daysAgo(90).slice(0, 10),
    maturity_date: null,
    payout_schedule: 'quarterly',
    status: 'closed',
    total_interest_paid: 33000,
    current_value: 783000,
    last_accrued_at: daysAgo(30),
    notes: 'Closed at investor request.',
    created_at: daysAgo(90),
  },
  {
    id: 4,
    reference: 'CINV-2026-000004',
    investor_id: 1,
    investor_name: 'Adaeze Okafor',
    plan_id: 3,
    plan_name: 'Fixed Return Plan — 24 Month',
    principal_amount: 300000,
    monthly_interest_rate: 2.4,
    start_date: null,
    maturity_date: null,
    payout_schedule: 'at_maturity',
    status: 'pending',
    total_interest_paid: 0,
    current_value: 300000,
    last_accrued_at: null,
    notes: 'Awaiting funding.',
    created_at: daysAgo(1),
  },
];

export const initialPlans = [
  {
    id: 1,
    name: 'Fixed Return Plan — 6 Month',
    description: 'A short-duration plan for investors who want returns without a long lock-in.',
    duration_months: 6,
    monthly_interest_rate: 1.8,
    min_amount: 50000,
    max_amount: 2000000,
    payout_schedule: 'monthly',
    is_active: true,
    created_at: daysAgo(300),
  },
  {
    id: 2,
    name: 'Fixed Return Plan — 12 Month',
    description: 'Our most popular plan — a full year at a stronger fixed monthly rate.',
    duration_months: 12,
    monthly_interest_rate: 2.0,
    min_amount: 100000,
    max_amount: 5000000,
    payout_schedule: 'monthly',
    is_active: true,
    created_at: daysAgo(300),
  },
  {
    id: 3,
    name: 'Fixed Return Plan — 24 Month',
    description: 'Our highest-yield plan for investors comfortable with a longer horizon.',
    duration_months: 24,
    monthly_interest_rate: 2.4,
    min_amount: 250000,
    max_amount: 10000000,
    payout_schedule: 'at_maturity',
    is_active: true,
    created_at: daysAgo(300),
  },
  {
    id: 4,
    name: 'Legacy Quarterly Plan',
    description: 'Retired plan kept for reference — no longer open to new subscriptions.',
    duration_months: 12,
    monthly_interest_rate: 1.6,
    min_amount: 100000,
    max_amount: 3000000,
    payout_schedule: 'quarterly',
    is_active: false,
    created_at: daysAgo(400),
  },
];

export const initialPayments = [
  {
    id: 1,
    investment_id: 1,
    investor_id: 1,
    amount: 500000,
    method: 'paystack',
    reference: 'PSK-REF-88213001',
    status: 'successful',
    note: null,
    created_at: daysAgo(120),
  },
  {
    id: 2,
    investment_id: 2,
    investor_id: 1,
    amount: 250000,
    method: 'manual',
    reference: 'GTB-TRF-55210',
    status: 'successful',
    note: 'Bank transfer confirmed by Ngozi Umeh.',
    created_at: daysAgo(200),
  },
  {
    id: 3,
    investment_id: 3,
    investor_id: 7,
    amount: 750000,
    method: 'paystack',
    reference: 'PSK-REF-71190045',
    status: 'successful',
    note: null,
    created_at: daysAgo(90),
  },
];

export const initialPayouts = [
  {
    id: 1,
    investment_id: 1,
    investor_id: 1,
    amount: 10000,
    method: 'paystack',
    reference: 'PSK-OUT-33021',
    status: 'completed',
    note: 'Monthly interest payout.',
    created_at: daysAgo(35),
  },
  {
    id: 2,
    investment_id: 1,
    investor_id: 1,
    amount: 10000,
    method: 'paystack',
    reference: 'PSK-OUT-33540',
    status: 'completed',
    note: 'Monthly interest payout.',
    created_at: daysAgo(5),
  },
  {
    id: 3,
    investment_id: 3,
    investor_id: 7,
    amount: 33000,
    method: 'manual',
    reference: 'GTB-OUT-9021',
    status: 'completed',
    note: 'Final payout on early closure.',
    created_at: daysAgo(30),
  },
];

export const initialNotifications = [
  {
    id: 1,
    user_id: 1,
    type: 'investment.activated',
    title: 'Investment activated',
    message: 'Your CINV-2026-000001 investment is now active.',
    read_at: daysAgo(119),
    created_at: daysAgo(120),
  },
  {
    id: 2,
    user_id: 1,
    type: 'payout.completed',
    title: 'Payout completed',
    message: '₦10,000 was paid out on CINV-2026-000001.',
    read_at: null,
    created_at: daysAgo(5),
  },
  {
    id: 3,
    user_id: 2,
    type: 'kyc.pending',
    title: 'KYC under review',
    message: 'Your KYC submission is pending admin review.',
    read_at: null,
    created_at: daysAgo(2),
  },
];

export const initialTickets = [
  {
    id: 1,
    investor_id: 1,
    investor_name: 'Adaeze Okafor',
    subject: 'Question about payout timing',
    category: 'payments',
    status: 'resolved',
    messages: [
      { id: 1, author: 'Adaeze Okafor', author_role: 'investor', body: 'When exactly does my monthly payout land?', created_at: daysAgo(40) },
      { id: 2, author: 'Ngozi Umeh', author_role: 'admin', body: 'Payouts are processed on the 1st of each month via Paystack.', created_at: daysAgo(39) },
    ],
    created_at: daysAgo(40),
    updated_at: daysAgo(39),
  },
  {
    id: 2,
    investor_id: 7,
    investor_name: 'Ibrahim Sule',
    subject: 'Update my bank account for payouts',
    category: 'account',
    status: 'open',
    messages: [
      { id: 1, author: 'Ibrahim Sule', author_role: 'investor', body: 'I changed banks — how do I update my payout account?', created_at: daysAgo(2) },
    ],
    created_at: daysAgo(2),
    updated_at: daysAgo(2),
  },
];

export const initialAuditLogs = [
  {
    id: 1,
    actor: 'Ngozi Umeh',
    actor_role: 'admin',
    action: 'investment.rate_updated',
    auditable_type: 'Investment',
    auditable_id: 1,
    before: { monthly_interest_rate: 1.8 },
    after: { monthly_interest_rate: 2.0, reason: 'Loyalty adjustment after 6 months' },
    ip_address: '105.112.24.6',
    created_at: daysAgo(5),
  },
  {
    id: 2,
    actor: 'Ngozi Umeh',
    actor_role: 'admin',
    action: 'kyc.approved',
    auditable_type: 'KycRecord',
    auditable_id: 1,
    before: { status: 'pending' },
    after: { status: 'approved' },
    ip_address: '105.112.24.6',
    created_at: daysAgo(115),
  },
  {
    id: 3,
    actor: 'Ngozi Umeh',
    actor_role: 'admin',
    action: 'kyc.rejected',
    auditable_type: 'KycRecord',
    auditable_id: 4,
    before: { status: 'pending' },
    after: { status: 'rejected', rejection_reason: 'ID document photo is blurry — please reupload a clearer copy.' },
    ip_address: '105.112.24.6',
    created_at: daysAgo(8),
  },
  {
    id: 4,
    actor: 'Chidi Eze',
    actor_role: 'super_admin',
    action: 'investor.deactivated',
    auditable_type: 'User',
    auditable_id: 7,
    before: { is_active: true },
    after: { is_active: false },
    ip_address: '197.210.55.19',
    created_at: daysAgo(15),
  },
  {
    id: 5,
    actor: 'Chidi Eze',
    actor_role: 'super_admin',
    action: 'admin_user.created',
    auditable_type: 'User',
    auditable_id: 3,
    before: null,
    after: { email: 'admin@demo.com', role: 'admin' },
    ip_address: '197.210.55.19',
    created_at: daysAgo(200),
  },
  {
    id: 6,
    actor: 'Ngozi Umeh',
    actor_role: 'admin',
    action: 'investment.status_updated',
    auditable_type: 'Investment',
    auditable_id: 3,
    before: { status: 'active' },
    after: { status: 'closed' },
    ip_address: '105.112.24.6',
    created_at: daysAgo(30),
  },
];
